export default __webpack_public_path__ + "static/media/riddler2.e2335772.jpg";